/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from 'react';
import { string } from 'prop-types';
import { Icon, PopoverMenu } from '@pwc/pwc-deals-ui';
import MenuButtonDelete from '../../MenuButtonDelete';
import MenuButtonEdit from '../../MenuButtonEdit/MenuButtonEdit';
import EnableForProjectState from '../../../../features/security/EnableForProjectState';
import ShowForPermissions from '../../../../features/security/ShowForPermissions';
import styles from './ContentActionsRowMenu.module.scss';

const lockedMessage = (name) =>
  `Unable to edit or delete the item as ${name} is currently editing.`;

const ContentActionsRowMenu = ({
  showInfoLockingUser,
  lockingUserName,
  isDisabled,
  projectId,
  itemId,
  onEditMenuClick,
  onDeleteMenuClick,
  direction,
  isEditDisabled,
}) => {
  const [show, setShow] = useState(false);
  const handleButtonClick = (handler) =>
    handler
      ? () => {
          setShow(false);
          handler(itemId);
        }
      : null;

  return (
    <ShowForPermissions projectId={projectId} permissions={['Contribute']}>
      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }) => (
          <PopoverMenu
            placement={isDisabled ? 'left-start' : direction}
            id="content-actions-moremenu"
            data-testid={`content-actions-popup-menu-${itemId}`}
            isButtonSecondary
            show={show}
            onToggle={(nextShow) => {
              setShow(nextShow);
            }}
          >
            <MenuButtonEdit
              isDisabled={isProjectDisabled || isDisabled || isEditDisabled}
              onClick={handleButtonClick(onEditMenuClick)}
            />
            <MenuButtonDelete
              isDisabled={isProjectDisabled || isDisabled}
              onClick={handleButtonClick(onDeleteMenuClick)}
            />
            {showInfoLockingUser && lockingUserName && (
              <div className={styles.infoLockedContainer}>
                <div className={styles.infoLockedIconContainer}>
                  <Icon
                    name="information"
                    width="18"
                    className="sr2 fill icon-yellow"
                  />
                </div>
                <div className={styles.infoLocked}>
                  {lockedMessage(lockingUserName)}
                </div>
              </div>
            )}
          </PopoverMenu>
        )}
      </EnableForProjectState>
    </ShowForPermissions>
  );
};

ContentActionsRowMenu.propTypes = {
  direction: string,
};

ContentActionsRowMenu.defaultProps = {
  direction: 'bottom',
};

export default ContentActionsRowMenu;
